import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const ErrorGraphic: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="ErrorGraphic"
      illustration={
        <svg
          width={restProps?.width ?? "455"}
          height={restProps?.height ?? "257"}
          viewBox="0 0 455 257"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M403.465 8.50579L389.222 12.144L392.86 26.3869L407.103 22.7486L403.465 8.50579Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M403.4 8.51025L407.1 22.7103L413.2 26.7103L409.5 12.5103L403.4 8.51025Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <g opacity="0.19">
            <path
              d="M146.1 235.089H105.3C102.5 235.089 100.2 232.789 100.2 229.989C100.2 227.189 102.5 224.889 105.3 224.889H146.1C148.9 224.889 151.2 227.189 151.2 229.989C151.2 232.789 148.9 235.089 146.1 235.089Z"
              fill="#D59AF8"
            />
            <path
              d="M167.901 194.189H122.801C120.201 194.189 118.101 192.089 118.101 189.489C118.101 186.889 120.201 184.789 122.801 184.789H167.901C170.501 184.789 172.601 186.889 172.601 189.489C172.701 192.089 170.501 194.189 167.901 194.189Z"
              fill="#D59AF8"
            />
            <path
              d="M171.9 214.289H87.4002C84.8002 214.289 82.7002 212.189 82.7002 209.589C82.7002 206.989 84.8002 204.889 87.4002 204.889H171.9C174.5 204.889 176.6 206.989 176.6 209.589C176.7 212.189 174.5 214.289 171.9 214.289Z"
              fill="#D59AF8"
            />
            <path
              d="M135.1 219.589C135.1 216.689 137.5 214.289 140.4 214.289H112.7C115.6 214.289 118 216.689 118 219.589C118 222.489 115.6 224.889 112.7 224.889H140.4C137.5 224.889 135.1 222.489 135.1 219.589Z"
              fill="#D59AF8"
            />
            <path
              d="M161.2 199.489C161.2 196.589 163.6 194.189 166.5 194.189H145.9C148.8 194.189 151.2 196.589 151.2 199.489C151.2 202.389 148.8 204.789 145.9 204.789H166.5C163.6 204.789 161.2 202.389 161.2 199.489Z"
              fill="#D59AF8"
            />
            <path
              d="M181.8 235.089H163.5C160.7 235.089 158.4 232.789 158.4 229.989C158.4 227.189 160.7 224.889 163.5 224.889H181.8C184.6 224.889 186.9 227.189 186.9 229.989C186.9 232.789 184.6 235.089 181.8 235.089Z"
              fill="#D59AF8"
            />
          </g>
          <path
            d="M221.901 91.689C227.601 91.689 232.301 95.989 233.001 101.489C252.401 106.389 266.801 123.989 266.801 144.889V183.589C266.801 189.489 271.601 194.189 277.401 194.189C280.201 194.189 282.401 196.389 282.401 199.189C282.401 201.989 280.201 204.189 277.401 204.189H166.601C163.801 204.189 161.601 201.989 161.601 199.189C161.601 196.389 163.901 194.289 166.701 194.189C172.501 194.189 177.301 189.389 177.301 183.589V144.789C177.301 144.189 177.301 143.589 177.301 142.889C177.301 142.589 177.301 142.289 177.401 141.989C177.401 141.589 177.501 141.289 177.501 140.889C177.501 140.489 177.601 140.189 177.601 139.789C177.601 139.489 177.701 139.289 177.701 138.989C180.101 120.789 193.401 106.089 210.801 101.489C211.401 95.989 216.201 91.689 221.901 91.689ZM221.901 89.689C215.701 89.689 210.401 93.989 209.001 99.989C200.501 102.389 193.001 107.189 187.101 113.889C180.901 120.889 176.901 129.489 175.701 138.789V138.889C175.701 139.189 175.601 139.389 175.601 139.689C175.601 140.089 175.501 140.489 175.501 140.889V141.289C175.501 141.489 175.501 141.789 175.401 141.989V142.089C175.401 142.389 175.401 142.689 175.301 142.989C175.301 143.689 175.301 144.289 175.301 144.889V183.589C175.301 188.289 171.501 192.189 166.701 192.189C162.701 192.189 159.601 195.289 159.601 199.189C159.601 203.089 162.701 206.189 166.601 206.189H277.401C281.301 206.189 284.401 203.089 284.401 199.189C284.401 197.289 283.701 195.589 282.401 194.289C281.101 192.989 279.401 192.289 277.601 192.189C277.501 192.189 277.501 192.189 277.401 192.189C272.601 192.189 268.801 188.289 268.801 183.589V144.989C268.801 123.989 254.901 105.589 234.801 99.989C233.401 93.989 228.001 89.689 221.901 89.689Z"
            fill="#D59AF8"
          />
          <g opacity="0.19">
            <path
              d="M282.8 197.089C282.8 197.089 282.2 195.989 282 195.389C280.4 195.289 280 194.089 278.7 193.389C276.1 192.689 272.6 192.489 270.7 190.189C267.6 186.489 267.8 181.789 268 177.189C268.3 171.589 267.9 165.989 267.8 160.389C267.1 159.389 267.5 157.789 267.6 156.089C267.7 153.189 268.2 150.189 267.9 147.289C267.6 145.089 267.6 143.289 267.4 141.089C267.1 136.089 266.4 131.489 264.1 126.789C264.1 126.689 264 126.589 264 126.489C263.8 126.289 263.6 126.089 263.4 125.889C260.7 122.789 259.4 119.189 257.1 115.889C256.1 114.489 255 113.289 253.9 111.989C253.2 111.189 251.5 109.089 251.5 109.089C251.5 109.089 248.7 107.789 247.8 106.789C244.2 104.689 242.2 103.689 238 102.689V102.589C236.1 102.189 234.4 100.989 233.5 99.2887C232.9 98.0887 232.4 96.8887 231.8 95.6887C231.7 95.3887 231.5 95.1887 231.4 94.8887C231.4 94.8887 231.3 94.8887 231.3 94.7887C230.4 94.3887 229.7 93.7887 229.2 93.0887C228.5 92.9887 227.7 92.8887 227 92.8887C221.3 92.8887 216.5 97.1887 215.9 102.789C198.5 107.289 185.2 122.089 182.8 140.289C182.8 140.589 182.7 140.789 182.7 141.089C182.7 141.489 182.6 141.789 182.6 142.189C182.6 142.589 182.5 142.889 182.5 143.289C182.5 143.589 182.5 143.889 182.4 144.189C182.4 144.789 182.4 145.389 182.4 146.089V184.889C182.4 190.689 177.7 195.489 171.8 195.489C169 195.489 166.7 197.689 166.7 200.489C166.7 203.289 168.9 205.489 171.7 205.489H280.1C280.4 205.089 280.7 204.689 281.1 204.389C281.5 204.089 281.9 203.689 282.3 203.289C282.5 203.089 282.6 202.989 282.6 203.089C282.9 202.689 283.1 202.189 283.3 201.789C283.7 201.089 284.2 200.289 284.6 199.589C283.8 198.789 283.3 197.989 282.8 197.089Z"
              fill="#D59AF8"
            />
          </g>
          <g opacity="0.19">
            <path
              d="M314.601 68.9889H272.801C270.501 68.9889 268.601 67.0889 268.601 64.7889C268.601 62.4889 270.501 60.5889 272.801 60.5889H314.601C316.901 60.5889 318.801 62.4889 318.801 64.7889C318.801 67.0889 316.901 68.9889 314.601 68.9889Z"
              fill="#D59AF8"
            />
            <path
              d="M252.9 66.9889H235.6C233.3 66.9889 231.4 65.0889 231.4 62.7889C231.4 60.4889 233.3 58.5889 235.6 58.5889H252.9C255.2 58.5889 257.1 60.4889 257.1 62.7889C257 65.0889 255.2 66.9889 252.9 66.9889Z"
              fill="#D59AF8"
            />
            <path
              d="M275.801 87.7889C273.001 85.0889 270.101 82.7889 266.501 81.0889C266.301 81.0889 266.101 80.9889 265.901 80.9889C264.901 80.8889 264.101 80.3889 263.701 79.5889H253.401C250.801 79.5889 248.601 81.6889 248.601 84.3889C248.601 87.0889 250.701 89.1889 253.401 89.1889H277.301C276.801 88.6889 276.301 88.2889 275.801 87.7889Z"
              fill="#D59AF8"
            />
            <path
              d="M331.601 79.5889H277.301C277.401 79.6889 277.501 79.6889 277.601 79.7889C279.501 81.0889 281.301 82.6889 283.101 84.1889C284.601 85.4889 286.201 86.6889 287.301 88.4889C287.401 88.6889 287.501 88.8889 287.501 89.0889H331.701C334.301 89.0889 336.501 86.9889 336.501 84.2889C336.501 81.5889 334.201 79.5889 331.601 79.5889Z"
              fill="#D59AF8"
            />
            <path
              d="M300.8 74.2888C300.8 71.3888 303.2 68.9888 306.1 68.9888H280.9C283.8 68.9888 286.2 71.3888 286.2 74.2888C286.2 77.1888 283.8 79.5888 280.9 79.5888H306.1C303.2 79.5888 300.8 77.1888 300.8 74.2888Z"
              fill="#D59AF8"
            />
          </g>
          <path
            d="M103.1 216.089V192.889H41.5V177.389L107.2 91.5889H128.1V170.789H147.4V192.889H128V216.089H103.1ZM72.1 170.789H103.1V130.089L72.1 170.789Z"
            fill="#ECAFFC"
          />
          <path
            d="M357.2 216.089V192.889H295.6V177.389L361.2 91.5889H382.1V170.789H401.5V192.889H382.1V216.089H357.2ZM326.2 170.789H357.2V130.089L326.2 170.789Z"
            fill="#ECAFFC"
          />
          <path
            d="M222 228.989C229.5 228.989 235.9 224.489 238.8 218.089C239.5 216.489 238.3 214.789 236.6 214.789H207.4C205.7 214.789 204.5 216.589 205.2 218.089C208.1 224.489 214.5 228.989 222 228.989Z"
            stroke="#D59AF8"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M254.701 88.7891C254.901 88.7891 255.101 88.7891 255.201 88.8891C262.401 90.3891 268.801 94.1891 273.801 99.6891C278.801 105.289 281.801 112.089 282.401 119.489C282.501 120.189 282.301 120.789 281.801 121.389C281.401 121.889 280.701 122.289 280.101 122.289C280.001 122.289 279.901 122.289 279.801 122.289C278.501 122.289 277.401 121.289 277.301 119.989C276.101 107.289 266.601 96.5891 254.101 93.8891C252.701 93.5891 251.801 92.1891 252.101 90.8891C252.401 89.6891 253.501 88.7891 254.701 88.7891ZM254.701 86.7891C252.601 86.7891 250.701 88.2891 250.201 90.3891C249.701 92.7891 251.201 95.1891 253.501 95.7891C253.601 95.7891 253.601 95.7891 253.701 95.7891C265.301 98.2891 274.201 108.289 275.301 120.089C275.501 122.489 277.501 124.189 279.801 124.189C279.901 124.189 280.101 124.189 280.201 124.189C281.401 124.089 282.501 123.489 283.301 122.589C284.101 121.589 284.501 120.489 284.301 119.189C283.601 111.389 280.401 104.089 275.201 98.1891C270.001 92.3891 263.201 88.3891 255.601 86.7891C255.301 86.8891 254.901 86.7891 254.701 86.7891Z"
            fill="#D59AF8"
          />
          <path
            d="M257.501 72.2891C257.701 72.2891 257.901 72.2891 258.001 72.3891C268.601 74.6891 278.1 80.1891 285.3 88.2891C292.6 96.4891 297.001 106.589 298.001 117.489C298.101 118.189 297.901 118.789 297.401 119.389C297 119.889 296.3 120.289 295.7 120.289C295.6 120.289 295.501 120.289 295.501 120.289C294.201 120.289 293.101 119.289 292.901 117.989C291.101 98.2891 276.2 81.5891 256.9 77.3891C255.5 77.0891 254.6 75.6891 254.9 74.3891C255.3 73.0891 256.401 72.2891 257.501 72.2891ZM257.501 70.2891C255.401 70.2891 253.501 71.7891 253.001 73.8891C252.701 75.0891 253 76.2891 253.6 77.2891C254.2 78.2891 255.2 78.9891 256.3 79.2891C256.4 79.2891 256.401 79.2891 256.501 79.3891C275.001 83.3891 289.201 99.2891 291.001 118.189C291.201 120.589 293.201 122.289 295.501 122.289C295.601 122.289 295.801 122.289 295.901 122.289C297.101 122.189 298.201 121.589 299.001 120.689C299.801 119.689 300.201 118.589 300.001 117.289C299.001 105.989 294.4 95.3891 286.8 86.8891C279.2 78.3891 269.4 72.6891 258.4 70.3891C258.1 70.2891 257.801 70.2891 257.501 70.2891Z"
            fill="#D59AF8"
          />
          <path
            d="M189.401 88.7891C190.601 88.7891 191.601 89.5891 191.901 90.7891C192.201 92.1891 191.301 93.5891 189.901 93.8891C177.401 96.5891 167.901 107.289 166.701 119.989C166.601 121.289 165.501 122.289 164.101 122.289C164.001 122.289 163.901 122.289 163.901 122.289C163.201 122.189 162.601 121.889 162.201 121.389C161.801 120.889 161.601 120.189 161.601 119.489C162.301 112.089 165.301 105.189 170.201 99.6891C175.101 94.1891 181.501 90.3891 188.801 88.8891C189.001 88.7891 189.201 88.7891 189.401 88.7891ZM189.401 86.7891C189.101 86.7891 188.801 86.7891 188.501 86.8891C180.901 88.4891 174.101 92.4891 168.801 98.2891C163.501 104.189 160.401 111.489 159.701 119.289C159.601 120.489 160.001 121.689 160.701 122.589C161.501 123.489 162.601 124.089 163.801 124.189C163.901 124.189 164.101 124.189 164.201 124.189C166.601 124.189 168.501 122.389 168.701 120.089C169.801 108.289 178.701 98.2891 190.301 95.7891C190.401 95.7891 190.401 95.7891 190.501 95.7891C192.901 95.1891 194.401 92.7891 193.801 90.3891C193.401 88.2891 191.501 86.7891 189.401 86.7891Z"
            fill="#D59AF8"
          />
          <path
            d="M186.501 72.2891C187.701 72.2891 188.701 73.0891 189.001 74.2891C189.301 75.6891 188.401 77.0891 187.001 77.3891C167.601 81.5891 152.801 98.2891 151.001 117.989C150.901 119.289 149.801 120.289 148.401 120.289C148.301 120.289 148.201 120.289 148.201 120.289C147.501 120.189 146.901 119.889 146.501 119.389C146.101 118.889 145.901 118.189 145.901 117.489C146.901 106.589 151.301 96.4891 158.601 88.2891C165.901 80.1891 175.301 74.6891 185.901 72.3891C186.201 72.2891 186.301 72.2891 186.501 72.2891ZM186.501 70.2891C186.201 70.2891 185.901 70.2891 185.601 70.3891C174.501 72.7891 164.701 78.4891 157.201 86.9891C149.601 95.4891 145.001 105.989 144.001 117.389C143.901 118.589 144.301 119.789 145.001 120.689C145.801 121.589 146.901 122.189 148.101 122.289C148.201 122.289 148.401 122.289 148.501 122.289C150.901 122.289 152.801 120.489 153.001 118.189C154.701 99.2891 168.901 83.3891 187.501 79.3891C187.601 79.3891 187.601 79.3891 187.701 79.3891C188.801 79.0891 189.801 78.3891 190.401 77.3891C191.101 76.3891 191.301 75.1891 191.001 73.9891C190.501 71.7891 188.601 70.2891 186.501 70.2891Z"
            fill="#D59AF8"
          />
          <path
            d="M215.801 171.589C215.801 171.589 218.701 165.389 227.301 165.389C235.901 165.389 238.101 171.589 238.101 171.589"
            stroke="#D59AF8"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M200.7 146.989C200.7 146.989 202.4 151.389 208.7 151.389C215 151.389 216.7 146.989 216.7 146.989"
            stroke="#D59AF8"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M237.101 146.989C237.101 146.989 238.801 151.389 245.101 151.389C251.401 151.389 253.101 146.989 253.101 146.989"
            stroke="#D59AF8"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M134.501 39.6887C134.501 35.3887 131.001 31.7887 126.601 31.7887C130.901 31.7887 134.501 28.2887 134.501 23.8887C134.501 28.1887 138.001 31.7887 142.401 31.7887C138.001 31.8887 134.501 35.3887 134.501 39.6887Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M295.601 153.489C295.601 149.889 292.701 146.989 289.101 146.989C292.701 146.989 295.601 144.089 295.601 140.489C295.601 144.089 298.501 146.989 302.101 146.989C298.501 146.989 295.601 149.889 295.601 153.489Z"
            fill="white"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M408 110.089C408 106.489 405.1 103.589 401.5 103.589C405.1 103.589 408 100.689 408 97.0889C408 100.689 410.9 103.589 414.5 103.589C410.9 103.689 408 106.589 408 110.089Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M230.6 115.289H236.1L230.2 124.289H237.2"
            stroke="#D59AF8"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M242.4 97.9891L249.8 97.2891L243 109.989L252.4 109.189"
            stroke="#D59AF8"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M229.201 72.2891L238.001 73.4891L226.601 86.5891L237.901 88.0891"
            stroke="#D59AF8"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M49.3801 76.9598L35.2725 72.8291L31.1418 86.9367L45.2494 91.0674L49.3801 76.9598Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M31.1006 86.9888L34.2006 93.7888L43.5006 96.5888L45.2006 91.0888L31.1006 86.9888Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M63.4631 81.1502L49.3555 77.0195L45.2248 91.1271L59.3324 95.2578L63.4631 81.1502Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M63.5008 81.0889L59.3008 95.2889L62.6008 101.789L66.7008 87.6889L63.5008 81.0889Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M59.3683 95.2611L45.2607 91.1304L41.13 105.238L55.2376 109.369L59.3683 95.2611Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M41.1006 105.289L44.2006 112.089L58.4006 116.189L55.2006 109.389L41.1006 105.289Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M59.3002 95.2891L55.2002 109.389L58.4002 115.989L62.6002 101.789L59.3002 95.2891Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M299.455 45.218C306.579 45.218 312.355 39.4424 312.355 32.318C312.355 25.1935 306.579 19.418 299.455 19.418C292.33 19.418 286.555 25.1935 286.555 32.318C286.555 39.4424 292.33 45.218 299.455 45.218Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M284.855 25.918C282.955 26.518 278.355 27.918 280.355 30.718C285.455 38.018 312.655 40.118 317.555 37.318C321.055 35.318 316.255 31.918 314.455 30.818"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M286.054 40.8179C285.454 42.5179 285.054 45.0179 285.954 46.7179C289.454 53.4179 302.454 38.2179 304.654 35.8179C307.554 32.5179 310.454 29.2179 312.454 25.3179C313.354 23.7179 314.654 21.6179 314.554 19.7179C314.254 15.3179 307.454 19.3179 305.754 20.7179"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <g opacity="0.19">
            <path
              d="M300.754 45.3182C307.161 45.3182 312.354 40.1247 312.354 33.7182C312.354 27.3117 307.161 22.1182 300.754 22.1182C294.348 22.1182 289.154 27.3117 289.154 33.7182C289.154 40.1247 294.348 45.3182 300.754 45.3182Z"
              fill="#D59AF8"
            />
          </g>
          <path
            d="M392.758 26.2084L378.516 29.8467L382.154 44.0895L396.397 40.4513L392.758 26.2084Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M382.101 44.1098L388.301 48.4098L402.601 44.7098L396.401 40.5098L382.101 44.1098Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M406.961 22.6254L392.718 26.2637L396.356 40.5065L410.599 36.8682L406.961 22.6254Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M396.4 40.5101L402.6 44.8101L416.8 41.1101L410.6 36.8101L396.4 40.5101Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M407 22.6099L410.6 36.8099L416.8 40.8099L413.1 26.6099L407 22.6099Z"
            stroke="#D59AF8"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
        </svg>

        // <svg
        //   xmlns="http://www.w3.org/2000/svg"
        //   width={restProps?.width ?? "23"}
        //   height={restProps?.height ?? "17"}
        //   viewBox="0 0 23 17"
        //   fill="none"
        //   {...props}
        // >
        //   <path
        //     d="M19.8248 0.854492H3.81389C2.16087 0.856473 0.821316 2.19602 0.819336 3.84905V13.8149C0.821316 15.468 2.16087 16.8075 3.81389 16.8095H19.8248C21.4778 16.8075 22.8174 15.468 22.8193 13.8149V3.84905C22.8174 2.19602 21.4778 0.856473 19.8248 0.854492ZM20.3039 5.35431L12.1348 10.453C11.9423 10.5755 11.6964 10.5755 11.5039 10.453L3.33476 5.35431C3.05361 5.179 2.9678 4.80897 3.14311 4.52781C3.31842 4.24666 3.68845 4.16085 3.96961 4.33616L11.8193 9.23925L19.6691 4.33616C19.9502 4.16085 20.3203 4.24666 20.4956 4.52781C20.6709 4.80897 20.5851 5.179 20.3039 5.35431Z"
        //     fill="#EF9CFF"
        //   />
        // </svg>
      }
      {...restProps}
    />
  );
};

export default ErrorGraphic;
